import _extends from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Layout from '@anm/components/video-landings/Layout';
import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import { DEFAULT_THEME } from '@anm/constants/videoLandings';
import { FontsContext } from '@anm/contexts/FontsContext';
import getIdFromUrlWithSlug from '@anm/helpers/get/getIdFromUrlWithSlug';
import getLandingTemplate from '@anm/helpers/getLandingTemplate';
import getRatioFromManifestResponse from '@anm/helpers/getRatioFromManifestResponse';
import getSafeManifest from '@anm/helpers/getSafeManifest';
import useChangeViewType from '@anm/hooks/useChangeViewType';
import { isVideoBlocked } from '@anm/hosting-player';
import { useContext } from 'react';
import MetaHead from '../src/components/MetaHead';
import Template from '../src/components/templates/Template';
import fetchData, { DataType } from '../src/helpers/fetchData';
import setHeaders from '../src/helpers/setHeaders';
import useRedirectToError from '../src/hooks/useRedirectToNotFound';
import PrivatePage from './private';
export var getServerSideProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var _configs, _meta, videoId, startTime, target, isLocalPlayer, isCustomDomain, page, manifestResponse, isManifestSuccess, manifest, isCustomization, landingErrorCode, landingError, isManifestBlocked, videoRatio, playerColor;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            videoId = getIdFromUrlWithSlug(context.query.videoId);
            startTime = context.query['t'] || 0;

            if (videoId) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", {
              props: {
                error: {
                  code: 404
                }
              }
            });

          case 5:
            setHeaders(videoId, context);
            target = context.query.target;
            isLocalPlayer = typeof context.query.local_player !== 'undefined';
            isCustomDomain = typeof context.query.cname !== 'undefined';
            _context.next = 11;
            return fetchData(videoId, DataType.page);

          case 11:
            page = _context.sent;
            _context.next = 14;
            return fetchData(videoId, DataType.manifest);

          case 14:
            manifestResponse = _context.sent;
            isManifestSuccess = manifestResponse.hasOwnProperty('main');
            manifest = _objectSpread(_objectSpread({}, manifestResponse), isCustomDomain && isManifestSuccess && {
              isEmbedded: true
            });
            isCustomization = target === 'customization';
            landingErrorCode = page["public"] === false && !isCustomization ? 403 : page.code;
            landingError = {
              code: landingErrorCode
            };
            isManifestBlocked = isVideoBlocked(manifest);
            videoRatio = getRatioFromManifestResponse(manifest, isManifestSuccess);
            playerColor = (isManifestSuccess ? (_configs = manifest.configs) === null || _configs === void 0 ? void 0 : _configs.playerColor : (_meta = manifest.meta) === null || _meta === void 0 ? void 0 : _meta.color) || DEFAULT_WAVE_COLOR;
            return _context.abrupt("return", {
              props: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                page: page,
                videoId: videoId,
                startTime: startTime,
                videoRatio: videoRatio,
                playerColor: playerColor,
                isLocalPlayer: isLocalPlayer
              }, target && {
                target: target
              }), isManifestBlocked && {
                manifest: manifest
              }), isManifestSuccess && {
                manifest: getSafeManifest(manifest)
              }), landingErrorCode && {
                error: landingError
              })
            });

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](0);
            throw new Error(_context.t0);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 26]]);
  }));

  return function getServerSideProps(_x) {
    return _ref.apply(this, arguments);
  };
}();

var Main = function Main(props) {
  var isCustomization = props.target === 'customization';
  var pageParams = props.page.parameters;

  var _useContext = useContext(FontsContext),
      family = _useContext.family;

  var viewType = useChangeViewType(isCustomization);
  var layoutProps = {
    viewType: viewType,
    isCustomization: isCustomization,
    variant: (pageParams === null || pageParams === void 0 ? void 0 : pageParams.theme) || DEFAULT_THEME,
    page: props.page,
    hasFooter: pageParams === null || pageParams === void 0 ? void 0 : pageParams.hasFooter,
    playerColor: props.playerColor,
    footerStyles: family === null || family === void 0 ? void 0 : family.body
  };
  var landingTemplate = getLandingTemplate(props.page.template, undefined, props.videoRatio);
  return __jsx(React.Fragment, null, __jsx(MetaHead, props), __jsx(Layout, layoutProps, __jsx(Template, _extends({}, props, {
    viewType: viewType,
    template: landingTemplate
  }))));
};

var PageGuard = function PageGuard(props) {
  var _props$error;

  var errorCode = (_props$error = props.error) === null || _props$error === void 0 ? void 0 : _props$error.code;
  useRedirectToError(errorCode);
  if (errorCode === 403) return __jsx(PrivatePage, props);
  return __jsx(React.Fragment, null, !errorCode ? __jsx(Main, props) : null);
};

export default PageGuard;